import type { OperationLogListResponse } from '@/models/operation-log'

/** v2 / レガシー共通の次ページ判定（いずれかの一覧 API の meta / links に準拠） */
export function hasOperationLogNextPage(
  meta: OperationLogListResponse['meta'] | undefined,
  links: OperationLogListResponse['links'] | undefined,
  listLength: number,
  perPage: number,
): boolean {
  const nextUrl = links?.next ?? meta?.next_page_url
  if (nextUrl != null && String(nextUrl).trim() !== '') return true
  if (meta?.current_page != null && meta?.last_page != null) {
    return meta.current_page < meta.last_page
  }
  return listLength >= perPage
}
